import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { hasBudgetsPermission } from '../../helpers/permissions';

const BudgetsMenuItems = ({ iconOnly, companyId, match, location }) => {
    const pathname = `/company/${companyId}`;

    function renderDetailsMenuItem() {
        const title = i18next.t('navDetailsTitle');
        const active = location.pathname === pathname;

        return (
            <Menu.Item key="details" as={Link} active={active} to={pathname} name={title}>
                <Icon name='info circle' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderGroupsMenuItem() {
        if (!hasBudgetsPermission('budgets')) return null;

        const title = i18next.t('navBudgetGroupsTitle');
        const active = location.pathname.startsWith(pathname + '/budgetgroups');

        return (
            <Menu.Item key="groups" as={Link} active={active} to={pathname + '/budgetgroups'}>
                <Icon name='chart pie' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderEmployeesMenuItem() {
        if (!hasBudgetsPermission('employees')) return null;

        const title = i18next.t('navWorkersTitle');
        const active = location.pathname.startsWith(pathname + '/workers');

        return (
            <Menu.Item key="employees" as={Link} active={active} to={pathname + '/workers'}>
                <Icon name='credit card outline' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderReportsMenuItem() {
        if (!hasBudgetsPermission('reports')) return null;

        const title = i18next.t('reports');
        const active = location.pathname.startsWith(pathname + '/report');

        return (
            <Menu.Item key="reports" as={Link} active={active} to={pathname + '/report'}>
                <Icon name='list alternate' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderOrdersMenuItem() {
        if (!hasBudgetsPermission('reports')) return null;

        const title = i18next.t('navOrdersTitle');
        const active = location.pathname.startsWith(pathname + '/orders');

        return (
            <Menu.Item key="orders" as={Link} active={active} to={pathname + '/orders'}>
                <Icon name='food' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    return (
        <Fragment>
            {renderDetailsMenuItem()}
            {renderGroupsMenuItem()}
            {renderEmployeesMenuItem()}
            {renderReportsMenuItem()}
            {renderOrdersMenuItem()}
        </Fragment>
    );
};

BudgetsMenuItems.propTypes = {
    companyId: PropTypes.string,
    
    match: PropTypes.any,
    location: PropTypes.any,
    iconOnly: PropTypes.bool,
};

export default BudgetsMenuItems;
